import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18124e34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "currency-input-container" }
const _hoisted_2 = ["step", "value"]

import { ref, computed } from 'vue';
import { CurrencySymbol } from '@/services/helpers/Helper';

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false
},
  __name: 'CurrencyInput',
  props: {
    modelValue: {},
    currency: { default: Object.keys(CurrencySymbol)[0] },
    step: { default: 0.01 }
  },
  setup(__props: any, { expose: __expose }) {

_useCssVars(_ctx => ({
  "2c1c2ee8": (symbol.value)
}))


// maybe use span instead of background image in alternative implementation
const props = __props;
__expose({
    isValid() { return inputEl.value?.validity?.valid; },
    getValidMsg() { return inputEl.value?.validationMessage; }
});
const inputEl = ref<HTMLInputElement>();
const symbolLen = ref(0);
const symbol = computed(()=>{
    symbolLen.value = (CurrencySymbol[props.currency] ?? CurrencySymbol.GBP).trim().length;
    return `"${CurrencySymbol[props.currency]??CurrencySymbol.GBP}"`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      class: {'currency-input-long': symbolLen.value > 1, 'currency-input' : symbolLen.value == 1 },
      type: "number",
      step: _ctx.step,
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event?.target as HTMLInputElement)?.value)))
    }), null, 16, _hoisted_2)
  ]))
}
}

})